//functional imports
import React, { useState } from 'react';
import moment from "moment";
// React-boostrap componets import
import {
    Jumbotron,
    Toast,
    Container,
    Col,
    Row,
    Button,
    Navbar,
    Nav,
    NavDropdown,
    Form,
    FormControl,
    Image,
    Badge
} from 'react-bootstrap';
//custom componets
//main css
import '../App.css';
//static files
import logo from '../mediumkpmg_logo.svg';
import line from '../line.svg';


const PageHeader = ({ children }) => {
    //componet logics
    const [componetState, setComponetState] = useState({});
    //component view
    return (
        <Navbar bg="light" expand="lg" style={style.navBar}>
            <Navbar.Brand href="#home">
                <img src={logo} style={style.logoSize} />
            </Navbar.Brand>
            {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Nav.Link href="#home" style={{fontFamily:"Sofia Pro", color:"black", fontSize:"18px"}}><b>KPMG Ethics Line</b></Nav.Link>
                </Nav>
                <Form inline>
                    <img src={line} style={style.logoSize} />
                    <Button variant="light" style={{ backgroundColor: style.color.grayScale, fontSize:"14px" }}>
                        {moment(new Date().toUTCString()).format("D MMMM, YYYY - h:mma")}
                    </Button>
                </Form>
            </Navbar.Collapse>
        </Navbar>
    );

};


//styles
const style = {
    navBar: {
        height: 70,
        paddingLeft:64.87,
        paddingRight:64.87,
        fontFamily:"Circular Std",
    },
    logoSize: {
        width: 65.46,
        height: 26.22
    },
    color: {
        grayScale: '#EDEDEE'
    }


}

//export componet
export default PageHeader;



